// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Modal
     */

    // Select elements in de DOM
    const openModalTriggers = document.querySelectorAll('.js-open-modal');
    const closeModalTriggers = document.querySelectorAll('.js-close-modal');
    const modals = document.querySelectorAll('.modal');

    // Open modal
    for (const openModalTrigger of openModalTriggers) {
        openModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = e.target.dataset.modal;
            openModal(modalId);
        });
    }

    const openModal = (modalId) => {
        for (const modal of modals) {
            if (modal.dataset.modal === modalId) {
                modal.classList.add('modal--visible');
                document.querySelector('body').classList.add('no-scroll');
            }
        }
    }

    // Close modal
    for (const closeModalTrigger of closeModalTriggers) {
        closeModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = e.target.dataset.modal;
            closeModal(modalId);
        });
    }

    const closeModal = (modalId) => {
        for (const modal of modals) {
            if (modal.dataset.modal === modalId) {
                modal.classList.remove('modal--visible');
                document.querySelector('body').classList.remove('no-scroll');
            }
        }
    }

});
